(() => {
  "use strict";
  function t() {
      this.entries = [];
  }
  function e(t) {
      if ("object" != typeof t) throw new TypeError(t + " is not an object.");
      if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
  }
  function n(e, n, i) {
      (this.element = e),
          (this.product = (function (t) {
              if ("object" != typeof t) throw new TypeError(t + " is not an object.");
              if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
              return t;
          })(n)),
          (i = i || {}),
          (this._listeners = new t()),
          this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
          (this.optionInputs = this._initInputs('[name^="options"]', i.onOptionChange)),
          (this.quantityInputs = this._initInputs('[name="quantity"]', i.onQuantityChange)),
          (this.propertyInputs = this._initInputs('[name^="properties"]', i.onPropertyChange));
  }
  (t.prototype.add = function (t, e, n) {
      this.entries.push({ element: t, event: e, fn: n }), t.addEventListener(e, n);
  }),
      (t.prototype.removeAll = function () {
          this.entries = this.entries.filter(function (t) {
              return t.element.removeEventListener(t.event, t.fn), !1;
          });
      }),
      (n.prototype.destroy = function () {
          this._listeners.removeAll();
      }),
      (n.prototype.options = function () {
          return (
              (t = this.optionInputs),
              (e = function (t) {
                  return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
              }),
              t.reduce(function (t, n) {
                  return (n.checked || ("radio" !== n.type && "checkbox" !== n.type)) && t.push(e({ name: n.name, value: n.value })), t;
              }, [])
          );
          var t, e;
      }),
      (n.prototype.variant = function () {
          return (function (t, n) {
              e(t);
              var i = (function (t, n) {
                  e(t),
                      (function (t) {
                          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                          if (0 === t.length) return [];
                          if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                          if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.");
                      })(n);
                  var i = [];
                  return (
                      n.forEach(function (e) {
                          for (var n = 0; n < t.options.length; n++)
                              if (t.options[n].name.toLowerCase() === e.name.toLowerCase()) {
                                  i[n] = e.value;
                                  break;
                              }
                      }),
                      i
                  );
              })(t, n);
              return (function (t, n) {
                  return (
                      e(t),
                      (function (t) {
                          if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
                      })(n),
                      t.variants.filter(function (t) {
                          return n.every(function (e, n) {
                              return t.options[n] === e;
                          });
                      })[0] || null
                  );
              })(t, i);
          })(this.product, this.options());
      }),
      (n.prototype.properties = function () {
          var t,
              e,
              n =
                  ((t = this.propertyInputs),
                  (e = function (t) {
                      return /(?:^(properties\[))(.*?)(?:\])/.exec(t)[2];
                  }),
                  t.reduce(function (t, n) {
                      return (n.checked || ("radio" !== n.type && "checkbox" !== n.type)) && (t[e(n.name)] = n.value), t;
                  }, {}));
          return 0 === Object.entries(n).length ? null : n;
      }),
      (n.prototype.quantity = function () {
          return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
      }),
      (n.prototype._setIdInputValue = function (t) {
          var e = this.element.querySelector('[name="id"]');
          e || (((e = document.createElement("input")).type = "hidden"), (e.name = "id"), this.element.appendChild(e)), (e.value = t.toString());
      }),
      (n.prototype._onSubmit = function (t, e) {
          (e.dataset = this._getProductFormEventData()), e.dataset.variant && this._setIdInputValue(e.dataset.variant.id), t.onFormSubmit && t.onFormSubmit(e);
      }),
      (n.prototype._onFormEvent = function (t) {
          return void 0 === t
              ? Function.prototype
              : function (e) {
                    (e.dataset = this._getProductFormEventData()), t(e);
                }.bind(this);
      }),
      (n.prototype._initInputs = function (t, e) {
          return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
              function (t) {
                  return this._listeners.add(t, "change", this._onFormEvent(e)), t;
              }.bind(this)
          );
      }),
      (n.prototype._getProductFormEventData = function () {
          return { options: this.options(), variant: this.variant(), properties: this.properties(), quantity: this.quantity() };
      });
  class i {
      constructor(t, e, n = null, i = null) {
          try {
              if (!t || (t && t.nodeType !== Node.ELEMENT_NODE)) throw new Error("Invalid 'containerElement' parameter.");
              if (!e || (e && e.nodeType !== Node.ELEMENT_NODE)) throw new Error("Invalid 'inputElement' parameter.");
              (this.containerElement = t),
                  (this.inputElement = e),
                  (this.plusElement = n),
                  (this.minusElement = i),
                  (this.max = this.inputElement.hasAttribute("max") ? Number(this.inputElement.getAttribute("max")) : null),
                  (this.min = this.inputElement.hasAttribute("min") ? Number(this.inputElement.getAttribute("min")) : 1),
                  (this.step = this.inputElement.hasAttribute("step") ? Number(this.inputElement.getAttribute("step")) : 1),
                  this.plusElement && this.plusElement.addEventListener("click", this.onClickPlus.bind(this)),
                  this.minusElement && this.minusElement.addEventListener("click", this.onClickMinus.bind(this));
          } catch (t) {}
      }
      onClickPlus() {
          let t = parseInt(this.inputElement.value, 10) || this.min,
              e = null != this.max && parseInt(t + this.step, 10) >= this.max ? this.max : parseInt(t + this.step, 10);
          t !== e && ((this.inputElement.value = e), this.dispatchChangeEvent(this.inputElement));
      }
      onClickMinus() {
          let t = parseInt(this.inputElement.value, 10) || this.min,
              e = parseInt(t - this.step, 10) <= this.min ? this.min : parseInt(t - this.step, 10);
          t !== e && ((this.inputElement.value = e), this.dispatchChangeEvent(this.inputElement));
      }
      dispatchChangeEvent(t) {
          if (!t) return;
          let e;
          "function" == typeof Event ? (e = new Event("change")) : ((e = document.createEvent("Event")), e.initEvent("change", !0, !0)), t.dispatchEvent(e);
      }
  }
  var r, o;
  (r = {
      async onLoad() {
          (this.sectionName = "product"),
              new (class {
                  constructor(t, e) {
                      (this.container = t), (this.options = e);
                  }
                  init() {
                      try {
                          if ((this.createSettings(), this.createSelectors(), this.createElements(), !this.elements.containers || !this.elements.containers.length)) return;
                          this.implementSearch(), this.createAccordions(), this.openFirstBelow(), delete this.init;
                      } catch (t) {}
                  }
                  createAccordions() {
                      this.elements.containers.forEach((t) => {
                          t.querySelectorAll(this.selectors.toggle).forEach((e) => {
                              const n = t.querySelector(`#${e.getAttribute("aria-controls")}`);
                              n &&
                                  e.addEventListener("click", (t) => {
                                      "true" !== e.getAttribute("aria-expanded")
                                          ? (this.settings.multiple || this.collapseAll(), e.setAttribute("aria-expanded", !0), n.setAttribute("data-open", !0))
                                          : this.settings.multiple
                                          ? (e.setAttribute("aria-expanded", !1), n.removeAttribute("data-open"))
                                          : this.collapseAll();
                                  });
                          });
                      });
                  }
                  openFirstBelow() {
                      window.innerWidth < 1280 && (this.collapseAll(), this.openFirst());
                  }
                  implementSearch() {
                      this.elements.search && this.elements.search.addEventListener("input", this.onSearch.bind(this));
                  }
                  onSearch(t) {
                      const e = t.target.value.toLowerCase();
                      this.elements.groups.forEach((t) => {
                          e && -1 === t.textContent.trim().toString().toLowerCase().indexOf(e) ? t.setAttribute("hidden", !0) : t.removeAttribute("hidden");
                      }),
                          this.elements.accordions.forEach((t) => {
                              const e = t.querySelectorAll("[data-accordion-group]");
                              0 == Array.from(e).filter((t) => !t.hasAttribute("hidden")).length ? t.setAttribute("hidden", !0) : t.removeAttribute("hidden");
                          });
                  }
                  collapseAll() {
                      this.elements.containers.forEach((t) => {
                          t.querySelectorAll(this.selectors.toggle).forEach((e) => {
                              const n = t.querySelector(`#${e.getAttribute("aria-controls")}`);
                              n && (e.setAttribute("aria-expanded", !1), n.removeAttribute("data-open"));
                          });
                      });
                  }
                  openFirst() {
                      const t = this.elements.containers[0],
                          e = document.querySelector(this.selectors.toggle),
                          n = t.querySelector(`#${e.getAttribute("aria-controls")}`);
                      n && (e.setAttribute("aria-expanded", !0), n.setAttribute("data-open", !0));
                  }
                  createSettings() {
                      this.settings = { multiple: !!this.options.hasOwnProperty("multiple") && this.options.multiple, openFirst: !!this.options.hasOwnProperty("openFirst") && this.options.openFirst };
                  }
                  createSelectors() {
                      this.selectors = { toggle: "[data-accordion-toggle]" };
                  }
                  createElements() {
                      this.elements = {
                          containers: document.querySelectorAll(this.container),
                          accordions: document.querySelectorAll("[data-accordion]"),
                          groups: document.querySelectorAll("[data-accordion-group]"),
                          results: document.querySelector("[data-accordion-results]"),
                          search: document.querySelector("[data-accordion-search]"),
                      };
                  }
              })("[data-ticket-groups]", { multiple: !0 }).init();
          let t = document.querySelector("[data-product-form]");
          if (t) {
              let e = t.dataset.productHandle;
              (this.product = await this.getProductJson(e)),
                  this.initQuantity(),
                  this.checkProductHasOptions(this.product) &&
                      (this.productForm = new n(t, this.product, { onOptionChange: this.onOptionChange.bind(this), onQuantityChange: this.onQuantityChange.bind(this), onPropertyChange: this.onPropertyChange.bind(this) }));
          }
      },
      onUnload() {},
      checkProductHasOptions(t = {}) {
          if (t.hasOwnProperty("options") && Array.isArray(t.options) && t.options.length > 0) {
              if (t.options.filter((t) => t.hasOwnProperty("name") && "Title" !== t.name).length) return !0;
              if (t.options.filter((t) => t.hasOwnProperty("values") && -1 === t.values.indexOf("Default Title")).length) return !0;
          }
          return !1;
      },
      getProductJson: (t) => fetch(`/products/${t}.js`).then((t) => t.json()),
      onOptionChange(t) {
          let e = t.dataset.variant;
          e && (this.updateInfoTables(e), this.updateSubmitButton(e), this.updateBrowserHistory(e));
      },
      updateInfoTables(t) {
          const e = `${this.product.url}?variant=${t.id}`;
          this.updateSection(this.sectionName, "[data-productjs-update]", "data-productjs-update", e);
      },
      onQuantityChange(t) {},
      onPropertyChange(t) {},
      onFormSubmit(t) {
          t.preventDefault();
      },
      updateSubmitButton(t) {
          let e = this.container.querySelector("[data-product-submit-button]"),
              n = this.container.querySelector("[data-product-submit-button-text]");
          t ? (t.available ? ((e.disabled = !1), (n.innerText = theme.strings.addToCart)) : ((e.disabled = !0), (n.innerText = theme.strings.soldOut))) : ((e.disabled = !0), (n.innerText = theme.strings.unavailable));
      },
      updateBrowserHistory(t) {
          if (!t) return;
          let e = (function (t, e) {
              return /variant=/.test(t) ? t.replace(/(variant=)[^&]+/, "$1" + e) : /\?/.test(t) ? t.concat("&variant=").concat(e) : t.concat("?variant=").concat(e);
          })(window.location.href, t.id);
          window.history.replaceState({ path: e }, "", e);
      },
      initQuantity() {
          const t = document.querySelector("[data-product-qty]"),
              e = t.querySelector("[data-product-qty-input]");
          if (t && e) return new i(t, e);
      },
      async updateSection(t, e, n, i = theme.url) {
          const r = -1 === i.indexOf("?") ? `${i}?sections=${t}` : `${i}&sections=${t}`;
          let o = await fetch(r, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
          const s = await o.json(),
              a = document.createElement("div");
          (a.innerHTML = s[t]),
              document.querySelectorAll(e).forEach((t) => {
                  const i = t.getAttribute(n),
                      r = a.querySelector(`${e.slice(0, e.length - 1)}="${i}"]`);
                  t.parentNode.replaceChild(r, t);
              });
      },
  }),
      (o = { name: "section-product", events: r }),
      theme.sections.push(o);
})();
